<!--
     main app.component delegates all app layout and routing
     to layout.component and layout-routing.module
-->
<div>
  <cvc-environment-banner></cvc-environment-banner>
</div>
<div class="alert-container">
  <cvc-network-error-alert></cvc-network-error-alert>
</div>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
